import React, {createContext, useReducer, useEffect} from 'react';
import axios from 'axios';

const url_stock = '/.netlify/functions/getstock';
const url_days = '/.netlify/functions/getDays';
export const initialState = {
  stock: [],
  days: [],
};

// create context for dispatch
export const StoreContext = createContext(initialState);

const reducer = (state, action) => {
  switch ((state, action.type)) {
    case 'setStock':
      return {...state, ...{stock: action.payload}};
    case 'setDays':
      return {...state, ...{days: action.payload}};
    default:
      return state;
  }
};

const StoreProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  // update state
  useEffect(() => {
    axios
      .get(url_stock)
      .then(function ({data}) {
        if (Array.isArray(data)) {
          dispatch({type: 'setStock', payload: data});
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
    axios
      .get(url_days)
      .then(function ({data}) {
        if (Array.isArray(data)) {
          dispatch({type: 'setDays', payload: data});
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  }, []);

  return (
    <StoreContext.Provider value={state}>{children}</StoreContext.Provider>
  );
};

export default StoreProvider;
